export default {
    namespaced:true,
    state:{
        keywrod:"", //搜索的字符
        tabindex:"Lubrication", //默认的tabs
        deviceType:"", //设备类型
        indicator:"" //关联故障
    },
    mutations:{
        setkeword(state,keywod){
         state.keywrod=keywod
        },
        settabindex(state,index){
            state.tabindex=index
        },
        setdeviceType(state,index){
            state.deviceType=index
        },
        setindicator(state,index){
            state.indicator=index
        }
    }
}